const SKILL_TYPE = {
  skill: 'SKILL',
  strongPoint: 'STRONG_POINT',
};

export default SKILL_TYPE;
